<script setup lang="ts">
/**
 * The Puida footer: a separator over the page palette's radial gradient, as
 * puida.com's FooterSimple, so every Puida site ends the same way (§11a).
 */
import { gradientStyle } from '@sulje/brand';
import { pagePalette } from '@/lib/palette';
import PuidaSeparator from './PuidaSeparator.vue';
import { consentBannerOpen } from '@/lib/consent';
import { askForConsent } from '@/lib/analytics-consent';

withDefaults(defineProps<{ fromColor?: string }>(), { fromColor: 'var(--brand-bg)' });

const background = gradientStyle(pagePalette);
const year = new Date().getFullYear();
</script>

<template>
  <footer class="text-white" :style="background">
    <PuidaSeparator :from-color="fromColor" />
    <div
      class="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-x-6 gap-y-3 px-4 pt-6 pb-9 text-sm sm:px-8"
    >
      <small class="text-sm text-white/90">{{ $t('footer.copyright', { year }) }}</small>
      <span class="text-white/60">
        <a href="https://puida.com/privacy/" class="text-white hover:underline">{{
          $t('footer.privacy')
        }}</a>
        |
        <a href="https://puida.com/terms/" class="text-white hover:underline">{{
          $t('footer.terms')
        }}</a>
        <template v-if="askForConsent">
          |
          <button
            type="button"
            class="text-white hover:underline"
            @click="consentBannerOpen = true"
          >
            {{ $t('footer.cookies') }}
          </button>
        </template>
      </span>
    </div>
  </footer>
</template>
